export interface User {
  _id: string;
  email: string;
  name: string;
  profilePicture?: string;
  role: UserRole;
  createdAt: Date;
  updatedAt: Date;
}

export enum UserRole {
  NORMAL = 'Normal',
  ADMIN = 'Admin'
}

export interface CreateUserRequest {
  email: string;
  name: string;
  password: string;
}

export interface UpdateUserRequest {
  name?: string;
  profilePicture?: string;
  role?: UserRole;
}